/* eslint-disable no-undef */
import React from "react";

const ProductLoader = React.forwardRef((props, ref) => (
  <div ref={ref} id="estimate-product-loader">
    <img
      src="assets/images/ajax-loader.gif"
      className="img-fluid"
      alt="Loading..."
    />
  </div>
));

export default ProductLoader;
